import { Shield, Github, Twitter, Linkedin } from "lucide-react";

const footerLinks = {
  services: [
  { name: "Secure Infrastructure", href: "#services" },
  { name: "Private Surveillance", href: "#services" },
  { name: "Hardened Automation", href: "#services" },
  { name: "Local AI", href: "#services" }],

  company: [
  { name: "About Us", href: "#" },
  { name: "Our Process", href: "#process" },
  { name: "Testimonials", href: "#testimonials" },
  { name: "Contact", href: "#contact" }],

  legal: [
  { name: "Privacy Policy", href: "#" },
  { name: "Terms of Service", href: "#" },
  { name: "Cookie Policy", href: "#" }]

};

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="relative py-16 md:py-20 border-t border-white/5"
      data-testid="footer">

      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-12 mb-16">
          {/* Brand */}
          <div className="col-span-2">
            <a href="#" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-[#5e5ce6]/20 flex items-center justify-center border border-[#5e5ce6]/30">
                <Shield className="w-5 h-5 text-[#5e5ce6]" />
              </div>
              <span className="text-xl font-semibold tracking-tight text-white">
                Fortress
              </span>
            </a>
            <p className="text-sm text-white/40 leading-relaxed max-w-xs mb-6">
              Premium smart home integration with uncompromising security. Your
              privacy is our priority.
            </p>

            {/* Social Links */}
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 transition-colors duration-300"
                aria-label="Twitter"
                data-testid="social-twitter">

                <Twitter className="w-4 h-4 text-white/60" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 transition-colors duration-300"
                aria-label="LinkedIn"
                data-testid="social-linkedin">

                <Linkedin className="w-4 h-4 text-white/60" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 transition-colors duration-300"
                aria-label="GitHub"
                data-testid="social-github">

                <Github className="w-4 h-4 text-white/60" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) =>
              <li key={link.name}>
                  <a
                  href={link.href}
                  className="text-sm text-white/40 hover:text-white/70 transition-colors duration-300">

                    {link.name}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) =>
              <li key={link.name}>
                  <a
                  href={link.href}
                  className="text-sm text-white/40 hover:text-white/70 transition-colors duration-300">

                    {link.name}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) =>
              <li key={link.name}>
                  <a
                  href={link.href}
                  className="text-sm text-white/40 hover:text-white/70 transition-colors duration-300">

                    {link.name}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30">
            &copy; {currentYear} Fortress Integration. All rights reserved.
          </p>
          <p className="text-xs text-white/30">Serving the New York Metro and Southern Florida Areas and beyond.

          </p>
        </div>
      </div>
    </footer>);

};